module.exports = __webpack_public_path__ + "media/images/emblems/Suscevaz-coat_of_arms-d1bebf9cc7e71b4a7ad52e205596522e.svg";